import { Box, Card, CardContent, Grid } from "@mui/material";
import React, { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { callBackendApi } from "../../methods/axiosInstances/backendInstance/apiRequest";
import DisputeCard from "../../components/disputes/DisputeCard";

const Disputes = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disputes, setDisputes] = useState([]);
  React.useEffect(() => {
    getDisputes();
  }, []);

  const getDisputes = async () => {
    const response = await callBackendApi("stripe/disputes");

    if (response.success) {
      const data = response.data.data;
      setDisputes(data);
    } else {
    }
  };

  return (
    <Box sx={{ width: "100%", maxWidth: "1700px", margin: "auto" }}>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <h1>Disputes</h1>
            </Grid>
            {disputes &&
              disputes.map((dispute) => {
                return (
                  <Grid item xs={12} md={6}>
                    <DisputeCard key={dispute.id} dispute={dispute} getDisputes={getDisputes} />
                  </Grid>
                );
              })}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Disputes;
